<template>
  <div v-if="variant" class="variant-thumb flex flex-col h-full">
    <float
      :reverse="floatReverse"
      :offset="floatOffset"
      :speed="floatSpeed"
      :stopped="floatStopped"
      no-hover-color
      class="variant-thumb__link flex flex-auto w-full"
    >
      <div class="relative flex-auto">
        <recess-image
          v-if="variant.image"
          :src="variant.image.transformedSrc"
          :alt="variant.title"
          not-lazy
          no-ratio
          fluid
          contain
          class="variant-thumb__image relative"
        />
      </div>
    </float>
    <div class="variant-thumb__header">
      <h4 class="variant-thumb__title">
        {{ title || variant.title }}
      </h4>
      <h5 v-if="subtitle" class="variant-thumb__subtitle">
        {{ subtitle }}
      </h5>
    </div>
    <div class="flex-0 w-full">
      <add-variant-to-cart
        v-if="addToCart"
        :variant="variant"
        :product="product"
        :is-subscription="isSubscription"
        :interval="interval"
        class="variant-thumb__add-to-cart"
      />
    </div>
  </div>
</template>

<script>
import shopifyQuery from '~/shopify/queries/variant.gql'
import AddVariantToCart from '~/components/shop/add-variant-to-cart.vue'

export default {
  name: 'VariantThumb',

  components: {
    AddVariantToCart
  },

  props: {
    title: {
      default: undefined,
      type: String
    },
    subtitle: {
      default: undefined,
      type: String
    },
    product: {
      default: () => {},
      type: Object
    },
    variantId: {
      default: undefined,
      type: String
    },
    isSubscription: {
      default: false,
      type: Boolean
    },
    interval: {
      default: undefined,
      type: String
    },
    addToCart: {
      default: false,
      type: Boolean
    },
    floatReverse: {
      default: false,
      type: Boolean
    },
    floatOffset: {
      default: undefined,
      type: String
    },
    floatSpeed: {
      default: undefined,
      type: [Number, String]
    },
    floatStopped: {
      default: false,
      type: Boolean
    }
  },

  apollo: {
    variant: {
      query: shopifyQuery,
      client: 'storefront',
      variables() {
        return {
          id: this.variantId
        }
      },
      update({ node }) {
        return node
      },
      skip() {
        return !this.variantId
      },
      watchLoading(loading) {
        // exit if loading function isn't available
        if (!this.$nuxt?.$loading) {
          return
        }
        // must use `nextTIck` see: https://nuxtjs.org/docs/2.x/features/loading/#programmatically-starting-the-loading-bar
        this.$nextTick(() => {
          if (loading) {
            this.$nuxt.$loading.start()
          } else {
            this.$nuxt.$loading.finish()
          }
        })
      }
    }
  }
}
</script>
